// extracted by mini-css-extract-plugin
export default {"chipContainer":"rKbCp","fieldset":"h43yl","chipLabel":"PWXlK"};